// src/components/content/RiskRegister.js
import { useState } from 'react';
import {
  Box, Card,
  CardContent, Divider
} from '@mui/material';
import { useLocation, useParams } from 'react-router';
import { LoadingScreen } from 'src/components/loading-screen';
import Header from '../header';
import RenderField from '../../risk-register/render-field';
import WeeklyPayrolltableView from './weekly-view-table';
import WeeklyViewDrawComp from './weekly-view-draw-comp';

const PayrollViewpage = () => {
  const { id } = useParams();
  console.log("🚀 ~ PayrollViewpage ~ id:", id)
  const [loading, setLoading] = useState(false);



  const location = useLocation();
  const rowData = location?.state?.rowData;


  return (
    <>
      {loading ? (
        <Box height={700}>
          <LoadingScreen />
        </Box>
      ) : (
        <>
          <Header name="WEEKLY PAYROLL / TIMESHEET VIEW PAGE" />
          <Card sx={{ height: '100%', marginTop: '10px', overflow: 'hidden' }}>
            <CardContent>
                <Card sx={{ marginTop: '40px',  boxShadow: 1 }}>
                  <Box
                    p={4}
                    mt={0}
                    display="grid"
                    gridTemplateColumns="repeat(3, 1fr)"
                    gap={3}
                    alignItems="center"
                    borderBottom="1px solid #ddd"
                    pb={2}
                  >
                    <RenderField label="Date" value={rowData?.week_starting_date || ' '  } />
                    <RenderField label="Facility" value={rowData?.project?.name || ' '  } />
                    <RenderField label="Scope of Work" value={rowData?.scope_of_work || ' '  } />
                  </Box>
                  <Box
                    p={4}
                    mt={0}
                    display="grid"
                    gridTemplateColumns="repeat(3, 1fr)"
                    gap={3}
                    alignItems="center"
                    pt={2}
                  >
                    <RenderField
                      label="Supervisor"
                      value={
                        rowData?.supervisor?.first_name
                          ? `${rowData?.supervisor?.first_name} ${rowData?.supervisor?.last_name}`
                          : ' '  
                      }
                    />
                    <RenderField label="Week Ending" value={rowData?.week_ending_date || ' '  } />
                    <RenderField
                      label="Job Order Number / Project Number"
                      value={rowData?.project?.project_number || ' '  }
                    />
                  </Box>
                </Card>

              <Card sx={{ marginTop: '20px' }}>
                <WeeklyPayrolltableView data={rowData?.weekly_timesheet} />
                <Divider />
                  <WeeklyViewDrawComp 
                  rowData={rowData} 
                  
                  />
              </Card>
            </CardContent>
          </Card>

        </>
      )}
    </>
  );
};
export default PayrollViewpage;